import React, {useCallback, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyLineLevelCoveragesComponent.metadata.json5';
import messages from "gw-capability-fnol-ca-react/FNOLCA.messages";

const getCellCoverageName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};

const getCellCoverageLimit = (rowData) => {
    return (
        <span>
            {rowData.limit}
        </span>
    );
};

const getCellCoverageDeductible = (rowData) => {
    return (
        <span>
            {rowData.deductible}
        </span>
    );
};


function PolicyLineLevelCoveragesComponent(props) {
    const { value: currentPeriodDetails } = props;

    if (_.isEmpty(currentPeriodDetails) || currentPeriodDetails === undefined) {
        return null;
    }

   /*  if (_.isEmpty(currentPeriodDetails) || currentPeriodDetails === undefined) {
        return null;
    } */

    const { coverables } = currentPeriodDetails;

    const policyLineCoverages = useMemo(() => {
        const selectedCoverable = coverables.find((coverable) => {
            return (coverable.name === 'Commercial Property' || coverable.name === 'Residential Line');
        });
        if (selectedCoverable) {
            return selectedCoverable.coverages;
        }
    }, [currentPeriodDetails]);


    const overrides = {
        PolicyLineLevelCoveragesTable: {
            data: policyLineCoverages
        },
        policyLineLevelCoverageColumn: { onCell: getCellCoverageName },
        policyLineLevelLimitColumn: { onCell: getCellCoverageLimit },
        policyLineLevelDeductibleColumn: { onCell: getCellCoverageDeductible }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyLineCoverages}
            overrideProps={overrides}
        />
    );
}


PolicyLineLevelCoveragesComponent.propTypes = {
    value: PropTypes.shape({})
};

PolicyLineLevelCoveragesComponent.defaultProps = {
    value: []
};

export default PolicyLineLevelCoveragesComponent;
